import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const GraficoFrentes = ({ frentes }) => {
    const labels = frentes.map(item => `Frente ${item.COD_FRENTE}`);

    const entradaAutomatica = frentes.map(item => {
        const total = item.ENTRADA_AUTOMATICA + item.ENTRADA_AUTOMATICA_ALT + item.ENTRADA_MANUAL;
        return (item.ENTRADA_AUTOMATICA * 100) / (total || 1);
    });

    const entradaAutomaticaAlt = frentes.map(item => {
        const total = item.ENTRADA_AUTOMATICA + item.ENTRADA_AUTOMATICA_ALT + item.ENTRADA_MANUAL;
        return (item.ENTRADA_AUTOMATICA_ALT * 100) / (total || 1);
    });

    const entradaManual = frentes.map(item => {
        const total = item.ENTRADA_AUTOMATICA + item.ENTRADA_AUTOMATICA_ALT + item.ENTRADA_MANUAL;
        return (item.ENTRADA_MANUAL * 100) / (total || 1);
    });

    const data = {
        labels,
        datasets: [
            {
                label: 'Automática',
                data: entradaAutomatica,
                backgroundColor: '#4CAF50'
            }//,
            // {
            //     label: 'Auto. c/ Alteração',
            //     data: entradaAutomaticaAlt,
            //     backgroundColor: '#8BC34A'
            // },
            // {
            //     label: 'Manual',
            //     data: entradaManual,
            //     backgroundColor: '#BDBDBD'
            // }
        ]
    };

    const options = {
        plugins: {
            title: {
                display: true,
                text: 'Percentual de Entradas por Frente'
            },
            legend: { position: 'bottom' },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.dataset.label}: ${context.parsed.y.toFixed(2)}%`
                }
            },
            datalabels: {
                clip: false, // ← Isso impede o corte
                anchor: 'center',
                align: 'center',
                color: '#fff',
                formatter: (value) => `${value.toFixed(1)}%`,
                font: { weight: 'bold' }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true, // ← AQUI: barras empilhadas
                title: { display: true, text: 'Frentes' }
            },
            y: {
                stacked: true, // ← AQUI: barras empilhadas
                beginAtZero: true,
                max: 100,
                ticks: { callback: (value) => `${value}%` },
                title: { display: true, text: 'Percentual (%)' }
            }
        }
    };

    return (
        <div style={{ width: '100%', height: 400 }}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default GraficoFrentes;
